import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

export type ButtonAppearance = 'primary' | 'outline' | 'danger' | 'white';

@Component({
  selector: 'ticketing-button',
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  readonly appearance = input<ButtonAppearance>('primary');

  readonly buttonClick = output<MouseEvent>();
  readonly isEnabled = input<boolean>(true);
}
